import { createGlobalStyle } from 'styled-components';

import ReactIconsSVG from 'assets/fonts/react-icons.svg';
import ReactIconsWOFF from 'assets/fonts/react-icons.woff';
import ReactIconsTTF from 'assets/fonts/react-icons.ttf';

export const GlobalStyle = createGlobalStyle` 
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700&display=swap');
  @import url('https://fonts.googleapis.com/earlyaccess/opensanshebrew.css');
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  html {
    font-family: 'ProximaNova-Regular', sans-serif;
    margin: 0;
    padding: 0;
    font-size: 12px;
    box-sizing: border-box;
    letter-spacing: 0.5px;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    margin:0;
  }
 
 
  @font-face {
  font-family: 'react-icons';
  src: url(${ReactIconsTTF}) format('truetype'),
    url(${ReactIconsWOFF}) format('woff'),
    url(${ReactIconsSVG}) format('svg');
  font-weight: normal;
  font-style: normal;
}


  b {
    font-family: ${props => props.theme.fonts.bold};
  }
  .grecaptcha-badge { visibility: hidden; }
    /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .sortableHelper {

  }
  /* Firefox */
  input[type=number] {
    -moz-appearance:textfield;
  }


  @media (max-width: ${props => props.theme.mobile}) {
    background-color: ${props => props.theme.colors.palePink};
    width: 100%;
    overflow-y: auto;
    overflow-x: auto;
  }
`;
